<template>
  <div class="submitToView">
    <div class="headerBg">
      <img class="bg" :src="bgIMG" alt="" srcset="" />
    </div>
    <main v-show="!isSubmit">
      <header>
        <img :src="secure" alt="" srcset="" />
        <div class="title">{{ $t('vulnerability.title') }}</div>
      </header>
      <section>
        <van-form @submit="onSubmit" label-width="100%">
          <van-field
            class="custom-field"
            v-model="ruleForm.collName"
            :name="$t('vulnerability.vulnerabilityName')"
            :label="$t('vulnerability.vulnerabilityName')"
            :placeholder="$t('vulnerability.placeholder.name')"
            maxlength="120"
            :rules="[
              { required: true },
              // { max: 120, message: this.$t('vulnerability.rules.nameErr'), trigger: 'blur' },
              {
                validator: validateContent,
                message: $t('vulnerability.validTextContent'),
                trigger: 'onBlur',
              },]"
            label-position="top"
           
          />

          <van-field
            class="custom-field"
            :value="ruleForm.loopholeCategorytext"
            readonly
            clickable
            :name="$t('vulnerability.vulnerabilityClassification')"
            :label="$t('vulnerability.vulnerabilityClassification')"
            :placeholder="$t('vulnerability.placeholder.classification')"
            @click="showPopup = true"
            :rules="[{ required: true }]"
            right-icon="arrow-down"
          />
          <van-field
            class="custom-field"
            :value="ruleForm.loopholeTypeText"
            readonly
            clickable
            :disabled="ruleForm.loopholeCategory === ''"
            :name="$t('vulnerability.vulnerabilityType')"
            :label="$t('vulnerability.vulnerabilityType')"
            :placeholder="ruleForm.loopholeCategory === '' ? $t('vulnerability.placeholder.firstType') :$t('vulnerability.placeholder.type')"
            right-icon="arrow-down"
            @click="ruleForm.loopholeCategory !== '' ? showLoopholeType = true:''"
            :rules="[{ required: true }]"
          />
          <van-field
            class="custom-field"
            v-model="ruleForm.collContent"
            rows="10"
            autosize
            maxlength="1000"
            type="textarea"
            :name="$t('vulnerability.vulnerabilityDetail')"
            :label="$t('vulnerability.vulnerabilityDetail')"
            :placeholder="$t('vulnerability.placeholder.detail')"
            :rules="[
              { required: true },
              {
                validator: validateContent,
                message: $t('vulnerability.validTextContent'),
                trigger: 'onBlur',
              },
              ]"
            label-position="top"
          />
          <van-field
            class="custom-field"
            v-model="ruleForm.email"
            :name="$t('vulnerability.email')"
            :label="$t('vulnerability.email')"
            :placeholder="$t('vulnerability.placeholder.email')"
            :rules="[
              { required: true },
              {
                validator: (value) => {
                  return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(value)
                },
                message: $t('vulnerability.rules.emaillErr'),
                trigger: 'onBlur',
              },
            ]"
            label-position="top"
          />
          <div class="link"></div>
          <div class="upload">
            <el-upload
              class="upload-demo"
              :action="signedUrl"
              :on-remove="handleRemove"
              :before-upload="beforeUpload"
              :on-change="test"
              :on-exceed="handleExceed"
              :limit="10"
              :file-list="fileList"
              :auto-upload="false"
              :show-file-list="false"
              method="put"
            >
              <div class="upadd" :disabled="fileList.length >9">
                <el-button size="small" :disabled="fileList.length >9" class="modelButton">{{ $t('vulnerability.selectFile') }}</el-button>
                <div class="add">添加/add</div>
              </div>

              <div class="el-upload-tip">{{ $t('vulnerability.placeholder.format') }}</div>
            </el-upload>
            <div class="fileList">
              <div class="file" v-for="(item, index) in fileList">
                <div class="left"><img :src="fileImg" alt="" />{{ item.name }}</div>
                <div class="del" @click="delFile(item, index)">删除/delete</div>
              </div>
            </div>
          </div>
          <div class="link"></div>
          <div class="policy">
            <div class="left">
              <el-checkbox v-model="isChecked"></el-checkbox>
            </div>
            <div class="right" style="margin-left: 8px">
              <div class="top">
                {{ $t('vulnerability.readCN') }}<span @click="openDp">{{ $t('vulnerability.DisclosurePolicyCN') }}</span
                >{{ $t('vulnerability.ORCN') }}<span @click="openPr">{{ $t('vulnerability.PrivacyPolicyCN') }}</span>
              </div>
              <div class="bottom">
                {{ $t('vulnerability.readEN') }}
                <span @click="openDp">{{ $t('vulnerability.DisclosurePolicyEN') }}</span> {{ $t('vulnerability.OREN')
                }}<span @click="openPr">{{ $t('vulnerability.PrivacyPolicyEN') }}</span>
              </div>
            </div>
          </div>

          <div style="margin: 16px">
            <van-button block type="info" native-type="submit">{{ $t('vulnerability.submit') }}</van-button>
          </div>
        </van-form>

        <van-popup v-model:show="showPopup" position="bottom">
          <van-picker
            :title="$t('vulnerability.vulnerabilityClassification')"
            show-toolbar
            :columns="loopholeCategoryList"
            @confirm="onConfirm"
            @cancel="showPopup = false"
            cancel-button-text="关闭/close"
            confirm-button-text="确认/confirm"
            label-key="text"
          />
        </van-popup>
        <van-popup v-model:show="showLoopholeType" position="bottom">
          <van-picker
            :title="$t('vulnerability.vulnerabilityType')"
            show-toolbar
            :columns="loopholeTypeList"
            @confirm="onConfirmLoopholeType"
            @cancel="showLoopholeType = false"
            cancel-button-text="关闭/close"
            confirm-button-text="确认/confirm"
            label-key="text"
          />
        </van-popup>
      </section>
    </main>
    <submitSuc v-show="isSubmit" @back="isSubmit = false"></submitSuc>
  </div>
</template>

<script>
import Button from 'vant/lib/button'
import Form from 'vant/lib/form'
import Field from 'vant/lib/field'
import Popup from 'vant/lib/popup'
import Picker from 'vant/lib/picker'
import Uploader from 'vant/lib/uploader'
import {isEqual,cloneDeep} from 'lodash';
import 'vant/lib/button/style'
import 'vant/lib/form/style'
import 'vant/lib/field/style'
import 'vant/lib/popup/style'
import 'vant/lib/picker/style'
import 'vant/lib/uploader/style'
const axios = require('axios')

import { loopholeSubmit } from '../../api/index'
import submitSuc from '../../components/submitSucMobile'
export default {
  name: 'submitToView',
  components: {
    submitSuc,
    VanButton: Button,
    VanForm: Form,
    VanField: Field,
    VanPopup: Popup,
    VanPicker: Picker,
    VanUploader: Uploader,
  },
  data() {
    return {
      fileImg: require('../../assets/file.png'),
      bgIMG: require('../../assets/headerBg.png'),
      secure: require('../../assets/secure.png'),
      isRead: false,
      fileList: [],
      ruleForm: {
        collName: '',
        loopholeCategory: '',
        loopholeCategorytext: '',
        loopholeTypeText: '',
        loopholeType: '',
        collContent: '',
        email: '',
        annexList: [],
      },

      loopholeTypeList: [
        { value: 'Sensitive Info Leakage', text: '信息泄露 Sensitive Info Leakage' },
        { value: 'XSS Injection', text: 'XSS注入 XSS Injection' },
        { value: 'Code Exection', text: '代码执行 Code Exection' },
        { value: 'Android Privilege Vulnerability', text: '安全组件漏洞 Android Privilege Vulnerability' },
        { value: 'Fishing', text: '钓鱼欺骗 Fishing' },
        { value: 'Denial of Service', text: '拒绝服务 Denial of Service' },
        { value: 'Others', text: '其他 Others' },
      ],
      loopholeKey: {
        web: [
          { value: 'XSS Injection', text: 'XSS注入 XSS Injection' },
          { value: 'SQL Injection', text: 'SQL注入 SQL Injection' },
          { value: 'Commond Injection', text: '命令注入 Commond Injection' },
          { value: 'File Upload Issues', text: '文件上传漏洞 File Upload Issues' },
          { value: 'Sensitive Info Leakage', text: '信息泄露 Sensitive Info Leakage' },
          { value: 'File Include', text: '文件包含 File Include' },
          { value: 'Logic Vulnerability', text: '逻辑漏洞 Logic Vulnerability' },
          { value: 'Privilege Bypass CSRF', text: '权限绕过 Privilege Bypass CSRF' },
          {value: 'CSRF SSRF Issues',text:'CSRF、SSRF漏洞 CSRF、SSRF'},
          { value: 'Others', text: '其他 Others' },
        ],
        app: [
          { value: 'Sensitive Info Leakage', text: '信息泄露 Sensitive Info Leakage' },
          { value: 'XSS Injection', text: 'XSS注入 XSS Injection' },
          { value: 'Code Exection', text: '代码执行 Code Exection' },
          { value: 'Android Privilege Vulnerability', text: '安全组件漏洞 Android Privilege Vulnerability' },
          { value: 'Fishing', text: '钓鱼欺骗 Fishing' },
          { value: 'Denial of Service', text: '拒绝服务 Denial of Service' },
          { value: 'Others', text: '其他 Others' },
        ],
        hardware: [
          { value: 'Buffer Overflow', text: '溢出漏洞 Buffer Overflow' },
          { value: 'Local Elevation of Privilege', text: '本地提权 Local Elevation of Privilege' },
          { value: 'Unauthorized vulnerability', text: '越权漏洞 Unauthorized vulnerability' },
          { value: 'Denial of Service', text: '拒绝服务 Denial of Service' },
          { value: 'Logic Vulnerability', text: '设计缺陷/逻辑漏洞 Logic Vulnerability' },
          { value: 'Configuration Issues', text: '配置错误 Configuration Issues' },
          { value: 'Sensitive Info Leakage', text: '敏感信息泄露 Sensitive Info Leakage' },
          { value: 'Weak Encryption', text: '不安全加密算法 Weak Encryption' },
          { value: 'Middle attack', text: '中间人攻击 Middle attack' },
          { value: 'Others', text: '其他 Others' },
        ],
        system: [
          { value: 'Configuration Issues', text: '配置错误 Configuration Issues' },
          { value: 'Access Control Issues', text: '访问控制漏洞 Access Control Issues' },
          { value: 'Weak Credentials', text: '弱口令 Weak Credentials' },
          { value: 'Sensitive Info Leakage', text: '敏感信息泄露 Sensitive Info Leakage' },
          { value: 'Common Vulnerabilities', text: '系统基础软件漏洞 Common Vulnerabilities' },
          { value: 'Privilege Bypass', text: '未授权访问、权限绕过 Privilege Bypass' },
          { value: 'Denial of Service', text: '拒绝服务漏洞 Denial of Service' },
          { value: 'Others', text: '其他 Others' },
        ],
      },
      loopholeCategoryList: [
        { value: 'web', text: 'Web漏洞 Web APPlicantion' },
        { value: 'app', text: '移动端漏洞 Mobile Application' },
        { value: 'hardware', text: '智能硬件漏洞 Hardware' },
        { value: 'system', text: '系统网络漏洞 System/NetWork' },
      ],
      isSubmit: false,
      showPopup: false,
      showLoopholeType: false,
      signedUrl: '',
      isChecked: false,
      oldForm:{}
    }
  },
  mounted () {
    document.title = "如何提交漏洞"
  },
  watch: {
    'ruleForm.loopholeCategory': function (val) {
      this.loopholeTypeList = this.loopholeKey[val]
      this.ruleForm.loopholeType = this.loopholeTypeList[0].value
      this.ruleForm.loopholeTypeText = this.loopholeTypeList[0].text
    },
  },
  methods: {
    handleExceed (files, fileList) {
      this.$message.warning(`最多上传为10个文件，您选择了 ${files.length + fileList.length} 个文件。Up to 10 files can be uploaded, you have selected ${files. length+fileList. length} files`);
    },
    validateContent(value, rule) {
      // 移除空格和换行符后判断内容是否为空
      const contentWithoutSpaces = value.replace(/[\s\n\r]+/g, '');
      if (contentWithoutSpaces === '') {
        return false
      } 
    },
    handleInput(value) {
      if (/\s/.test(value)) {
        this.inputValue = value.replace(/\s/g, '');
      }
    },
    openDp() {
      window.open(`${location.origin}${location.pathname}#/vulnerabilitypolicy-show`)
    },
    openPr() {
      window.open('https://www.ugnas.com/policy/privacy-policy-3.html')
      // window.open(`${location.origin}${location.pathname}#/privacyPolicy`)
    },
    delFile(file, index) {
      this.ruleForm.annexList.splice(index, 1)
      this.fileList.splice(index, 1)
    },

    handleFileChange(file) {
      // 处理上传逻辑，获取 signedUrl 然后上传
      this.handleFileUpload(file)
    },
    test(file, fileList) {
      this.beforeUpload(file, fileList)
    },
    beforeUpload(file, fileList) {
      // 检查文件格式
      const allowedFormats = ['7z', 'rar', 'zip', 'gz']
      const isFormatValid = allowedFormats.some((format) => file.name.toLowerCase().endsWith(format))
      if (this.fileList.length > 9) {
        return this.$message.error('最多上传10个压缩文件 Upload up to 10 compressed files');
      } 
      if (!isFormatValid) {
        this.$message.error('文件格式不正确，请上传7z、rar、zip或gz格式的文件\n The file format is incorrect, please upload a file in 7z, rar, zip, or gz format.');
        return false // 阻止上传
      }

      // 检查文件大小
      const maxSize = 8 * 1024 * 1024 // 8MB
      if (file.size > maxSize) {
        this.$message.error('文件大小超过8MB，不允许上传\n The file size exceeds 8MB, and upload is not allowed.');
        return false // 阻止上传
      }

      this.handleFileUpload(file)
    },
    // 处理移除操作
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    // 处理文件上传操作
    handleFileUpload(file) {
      this.loading = true
      let data = {
        filePath: 'vulnerability/' +new Date().getTime()+'/'+file.name,
        fileType: 'LOOPHOLE_LOG',
      }
      this.getSignedUrl(data, file)
    },
    async getSignedUrl(data, file) {
      let path = process.env.NODE_ENV === 'development' ? 'https://api-test.ugnas.com/' : 'https://api-cn.ugnas.com/'
      let url = path + 'api/system/v2/ua/unauth/oss/url/auth'
      const response = await axios.get(url, {
        params: data,
      })
      let { signedUrl } = response.data.data
      this.signedUrl = signedUrl

      // 发送 HTTP PUT 请求上传文件
      axios
        .put(this.signedUrl, file.raw, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(() => {
          this.fileList.push(file)
          this.ruleForm.annexList.push(data.filePath)
          this.$message.success('上传成功 Upload successfully');
        })
        .catch((error) => {
          this.$message.error('上传失败 Upload failed');
        })
    },
    onConfirmLoopholeType(item) {
      this.ruleForm.loopholeType = item.value
      this.ruleForm.loopholeTypeText = item.text
      this.showLoopholeType = false
    },
    onConfirm(item) {
      this.ruleForm.loopholeCategory = item.value
      this.ruleForm.loopholeCategorytext = item.text
      this.showPopup = false
    },
    validateEmail(rule, value, callback) {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
      if (value === '' || emailRegex.test(value)) {
        callback()
      } else {
        callback(new Error(this.$t('vulnerability.rules.emaillErr')))
      }
    },
    onSubmit (formName) {
      const areObjectsEqual = isEqual(this.oldForm, this.ruleForm);
      if (this.isChecked) {
        if (areObjectsEqual) {
          this.isSubmit = true
        } else {
          loopholeSubmit(this.ruleForm).then((res) => {
            if (res.code !== 200) {
              return this.$message.error(res.msg);
            }
            this.oldForm = cloneDeep(this.ruleForm)
            this.isSubmit = true
          })
        }
      } else
      {
        this.$message.error('请阅读并同意漏洞披露政策与隐私政策\n Please read and agree to the vulnerability disclosure policy and privacy policy');
         
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
}
</script>
<style lang="less" scoped>
.custom-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
::v-deep .van-button {
  border-radius: 4px;
}

.custom-field label {
  margin-bottom: 8px;
}
.custom-field ::v-deep .van-field__label::before {
  content: '*'; /* 添加伪元素内容为 '*'，你可以根据需要修改内容和样式 */
  color: red; /* 修改伪元素的颜色 */
  margin: 0 4px; /* 设置伪元素与文本之间的距离 */
}
::v-deep .van-picker__title {
  font-size: 14px;
}
.submitToView {
  width: 100%;
  height: 100%;
  position: relative;
  .headerBg {
    width: 100%;
    position: absolute;
    z-index: -1;
    .bg {
      width: 100%;
    }
  }
  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    font-size: 14px;
    header {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 24px 0 16px;
      .title {
        font-size: 16px;
        font-weight: 500;
        color: #000000;
        line-height: 45px;
        padding-top: 16px;
      }
    }
    section {
      max-width: 560px;
      .link {
        height: 8px;
        background: #f8f8f8;
      }

      .submit {
        width: 100%;
      }
      .policy {
        padding: 10px 16px;
        display: flex;
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        line-height: 20px;
        .right {
          span {
            cursor: pointer;
            color: #1989ff;
          }
        }
      }
      .upload {
        box-sizing:border-box;
        max-width:100vw;
        padding: 10px 16px;
        .modelButton {
          border: 0 solid transparent;
          padding: 0;
          font-size: 14px;
          color: #000;
        }
        .upadd {
        
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
          .add {
            cursor: pointer;
            color: #1989ff;
          }
        }
        ::v-deep .el-upload {
          text-align: left;
        }
        .fileList {
          font-size: 14px;
          .file {
            max-width:100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 48px;
            .left {
              line-height:48px;
              flex: 1;
              white-space: nowrap; /* 不换行 */
              overflow: hidden; /* 隐藏溢出部分 */
              text-overflow: ellipsis; /* 显示省略号 */
               img {
                vertical-align: middle;
                margin-right:8px
               }
            }
            .del {
              flex-shrink: 0;
              margin-left: 10px;
              color: #1989ff;
              padding: 0 10px;
            }
          }
        }
      }
      .el-upload-tip {
        font-size: 13px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.3);
        line-height: 18px;
      }
    }
  }
  ::v-deep .van-field--error .van-field__control::placeholder {
    display: none;
  }
}
</style>
